import React, { useMemo } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  ChartDataset,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { isEqual } from "lodash";
import { EnergyManagementImport } from "../../../types/imports";

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement);

function EMFrontiersGraph() {
  const emImport: EnergyManagementImport | null = useSelector(
    (state: RootState) => state.imports?.importPreviews?.em,
    isEqual,
  );

  const chartData = useMemo(() => {
    if (
      !emImport ||
      !emImport.data ||
      !emImport.data.FrontierRaceMap3 ||
      !emImport.data.FrontierAttackMap2
    ) {
      return {
        labels: [],
        datasets: [],
      };
    }

    const frontierRaceMap3 = emImport.data.FrontierRaceMap3;
    const frontierAttackMap2 = emImport.data.FrontierAttackMap2;

    const datasets: ChartDataset<"line">[] = [];

    const raceMap3Data = frontierRaceMap3[0].map(
      (tLap: number, index: number) => ({
        x: frontierRaceMap3[1][index],
        y: tLap,
      }),
    );

    const attackMap2Data = frontierAttackMap2[0].map(
      (tLap: number, index: number) => ({
        x: frontierAttackMap2[1][index],
        y: tLap,
      }),
    );

    datasets.push({
      label: "Low Power",
      data: raceMap3Data,
      pointRadius: 2,
      borderColor: "#ffffff",
      borderWidth: 2,
      showLine: true,
    });

    datasets.push({
      label: "High Power",
      data: attackMap2Data,
      pointRadius: 2,
      borderColor: "lightskyblue",
      borderWidth: 2,
      showLine: true,
    });

    return {
      labels: [],
      datasets,
    };
  }, [emImport]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
        labels: {
          color: "#ffffff",
        },
      },
      title: {
        display: true,
        text: "EM Frontiers",
        color: "#ffffff",
      },
    },
    scales: {
      x: {
        type: "linear" as const,
        position: "bottom" as const,
        border: {
          color: "#ffffff",
        },
        grid: {
          color: "#505050",
        },
        ticks: {
          color: "#ffffff",
        },
        title: {
          display: true,
          text: "eLap (kWh)",
          color: "#ffffff",
        },
      },
      y: {
        grid: {
          color: "#505050",
        },
        ticks: {
          color: "#ffffff",
        },
        border: {
          color: "#ffffff",
        },
        title: {
          display: true,
          text: "tLap (s)",
          color: "#ffffff",
        },
      },
    },
  };

  return (
    <div className={styles.container}>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
}

export default EMFrontiersGraph;
